export default "__VITE_ASSET__eb71b410__"